import React from 'react';
import ApplicationCard from './ApplicationCard';
import { motion } from 'framer-motion';
import { JobApplication, ApplicationStatus } from '../../types/application';

interface ApplicationColumnProps {
  status: ApplicationStatus;
  title: string;
  applications: JobApplication[];
  onCardClick: (jobId: number) => void;
  onStatusChange: (applicationId: number, newStatus: ApplicationStatus) => void;
  onMoveToInterview: (applicationId: number) => void;
  index: number;
}

const ApplicationColumn: React.FC<ApplicationColumnProps> = ({
  title,
  applications,
  onCardClick,
  onStatusChange,
  onMoveToInterview,
  index
}) => {
  return (
    <div className="flex-1 min-w-[350px] bg-white rounded-xl shadow-sm p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium">
          {applications.length}
        </span>
      </div>

      <div className="space-y-3 min-h-[200px]">
        {applications.map((app) => (
          <ApplicationCard
            key={app.id}
            application={app}
            onCardClick={onCardClick}
            onStatusChange={onStatusChange}
            onMoveToInterview={onMoveToInterview}
          />
        ))}
      </div>
    </div>
  );
};

export default ApplicationColumn; 